import { render, staticRenderFns } from "./PrintableCalendarPagination.vue?vue&type=template&id=015cf252&scoped=true"
import script from "./PrintableCalendarPagination.ts?vue&type=script&lang=js&external"
export * from "./PrintableCalendarPagination.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015cf252",
  null
  
)

export default component.exports